import CheckBox from 'expo-checkbox';
import React, { memo, ReactNode } from 'react';
import { Platform, StyleProp, TextStyle, View, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import { color, palette } from '../../theme';
import { Text } from '../Text/Text';
import { CheckboxPresets, viewPresets } from './Checkbox.presets';

export interface CheckboxProps {
  style?: StyleProp<ViewStyle>;
  preset?: CheckboxPresets;
  label?: ReactNode;
  value?: boolean;
  disabled?: boolean;
  textStyle?: StyleProp<TextStyle>;
  onChange?: (value: boolean) => void;
}

/**
 * For your checkbox input displaying needs.
 *
 * This component can display a square or circular checkbox, according presets
 */
function Checkbox(props: CheckboxProps): JSX.Element {
  const {
    preset = 'square',
    label = '',
    value,
    style: styleOverride,
    textStyle,
    onChange,
    ...rest
  } = props;

  const is_checked = !!value;
  const style = viewPresets[preset] || viewPresets.square;

  const onPress = () => {
    if (!rest.disabled) {
      onChange?.(!value);
    }
  };

  const onValueChange = onChange
    ? (new_value: boolean) => {
        if (!rest.disabled) {
          onChange?.(new_value);
        }
      }
    : undefined;

  return (
    <Container style={styleOverride}>
      <ClickableArea onPress={onPress} activeOpacity={0.9}>
        <CheckboxContainer>
          <CheckBox
            color={is_checked ? style.color : palette.dim}
            value={is_checked}
            onValueChange={onValueChange}
          />
        </CheckboxContainer>

        {label ? <Label style={textStyle}>{label}</Label> : null}
      </ClickableArea>

      {label ? <EndSpacer /> : null}
    </Container>
  );
}

const Container = styled(View)`
  flex-direction: row;
`;

const CheckboxContainer = styled(View)`
  margin-top: ${Platform.select({ native: '6px', web: '3px' })};
`;

const ClickableArea = styled.TouchableOpacity`
  flex-direction: row;
  max-width: 100%;
`;

const EndSpacer = styled.View`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
`;

const Label = styled(Text)`
  color: ${color.text};
  margin-left: 8px;
  font-size: 18px;
`;

const checkBoxMemo = memo(Checkbox);

export { checkBoxMemo as Checkbox };
